module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-modal', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.title,
      "footer": null,
      "afterClose": _vm.afterClose,
      "width": 600,
      "maskClosable": false
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 12
      }
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "地块名称"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['areaName', {
        rules: [{
          required: true,
          message: '请输入地块名称'
        }]
      }]),
      expression: "['areaName', { rules: [{ required: true, message: '请输入地块名称' }] }]"
    }]
  })], 1), _vm._v(" "), (_vm.areaLevel >= 1) ? [_c('a-form-item', {
    attrs: {
      "label": "地块标题"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['areaTitle']),
      expression: "['areaTitle']"
    }]
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "简介"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['areaBrief']),
      expression: "['areaBrief']"
    }],
    attrs: {
      "placeholder": "",
      "allow-clear": "",
      "auto-size": {
        minRows: 2,
        maxRows: 6
      }
    }
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "上传图片"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList
    },
    on: {
      "change": function (e) { return _vm.handleChange(e); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.areaLevel >= 2) ? [_c('a-form-item', {
    attrs: {
      "label": "监控链接"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['monitorLink']),
      expression: "['monitorLink']"
    }]
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['price']),
      expression: "['price']"
    }],
    attrs: {
      "min": 0
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.areaLevel >= 3) ? [_c('a-form-item', {
    attrs: {
      "label": "种植面积"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['plotSize']),
      expression: "['plotSize']"
    }],
    attrs: {
      "min": 0,
      "precision": 0
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("m²")])], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "配送次数"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['deliveryCount']),
      expression: "['deliveryCount']"
    }],
    attrs: {
      "min": 0,
      "precision": 0
    }
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "有效期年数（年）"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['effectYear']),
      expression: "['effectYear']"
    }],
    attrs: {
      "min": 0,
      "precision": 0
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "wrapper-col": {
        span: 12,
        offset: 7
      }
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("确认")]), _vm._v(" "), (_vm.hasBtn) ? _c('a-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": _vm.toLower
    }
  }, [_vm._v("前往")]) : _vm._e(), _vm._v(" "), (_vm.hasBtn) ? _c('a-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.dele
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d92c744c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/LandDetail.vue
// module id = 1078
// module chunks = 1